package kz.dentalcrm.app.core.storage

import com.russhwolf.settings.Settings

class Storage(
    private val settings: Settings
) {

    fun saveCredo(
        login: String,
        password: String,
        accessToken: String
    ) {
        settings.putString(LOGIN, login)
        settings.putString(PASSWORD, password)
        settings.putString(ACCESS_TOKEN, accessToken)

    }

    fun getAccessToken(): String = settings.getStringOrNull(ACCESS_TOKEN) ?: ""

    fun clearData() {
        settings.clear()
    }

    companion object {
        private const val LOGIN = "login"
        private const val PASSWORD = "password"
        private const val ACCESS_TOKEN = "access"
    }
}